import HeaderList from '@app/HeaderList/HeaderList.vue';

export default function install(Vue) {
  Vue.component('HeaderList', HeaderList)
}
